<template>
  <nav class="tabs" :class="wrapperClass">
    <ul>
      <li
        class="tabs__item"
        v-for="(tab, index) in tabs"
        :ref="tab.value"
        :key="index"
        :class="[
            { 'tabs__item_active' : isActive(tab) },
            tab.value === currentTab && tabActiveClass ? tabActiveClass: '',
            tab.everActive ? tabActiveClass: '',
            tabClass,

        ]"
        :disabled="tab.disabled || false"
        @click="handleClick(tab)"
      >
        {{tab.title}}
        <span
          class='check fas '
          :class="[tab.checked ? 'fa-check-circle' : 'fa-exclamation-circle']"
          :style="[tab.checked === undefined ? {'display':'none'} : {}]"
        >
        </span>
        <slot name="tabRightSlot" :tab="tab" :index="index"></slot>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'vue-tabs-with-active-line',
  props: {
    currentTabValue: {
      type: [String, Number],
    },
    tabs: {
      type: Array,
      required: true,
    },
    updated: {
      type: [Boolean, String, Array],
      default: undefined,
    },
    wrapperClass: {
      type: String,
      required: false,
    },
    tabClass: {
      type: String,
      required: false,
    },
    tabActiveClass: {
      type: String,
      required: false,
    },
    lineClass: {
      type: String,
      required: false,
    },
    everActive: {
      type: Boolean,
      required: false,
    },
    onClick: {
      type: Function,
      required: false
    },
  },
  data: () => ({
    activeLineWidth: 0,
    activeLineOffset: 0,
  }),
  computed: {
    currentTab() {
      if(!this.currentTabValue) return null
      return this.tabs.find(tab => tab.value === this.currentTabValue)
    },
  },
  methods: {
    handleClick(tab) {
      if(typeof this.onClick === "function") return this.onClick(tab);
      this.setHash(tab);
    },
    setHash(tab) {
      this.$router.push({hash: tab.value})
    },
    isActive(tab) {
      if(!this.currentTab) return false
      return tab.value === this.currentTab.value
    }
  },
};
</script>

<style lang="scss"  >
  .check{
    position: relative;
    right: -1.5em;
    top: -.7em;
    margin-left: -12px;
  }

  .fa-exclamation-circle{
    color: #ec9148;
  }

  .fa-check-circle {
    color: #124200;
  }

  .tabs__item_active {
    border-color: #ec9148 !important;
  }
</style>